import utils from '../utils';
import { METHODS } from '../constants';

const schemes = () => ({
  getSchemeListUrl: (
    pageIndex: string | number,
    pageSize: string | number,
    category: string,
    subCategory: string,
    isSip: string
  ) => `${process.env.HOST}/api/mutual-fund/list?category=${category}&subCategory=${subCategory}&isSip=${isSip}`,
  getNfoSchemeListUrl: () => `${process.env.HOST}/api/mutual-fund/nfo-list`,
  getDigiToken: () => `${process.env.HOST}/api/getDigiToken`,
  getSchemeDetailsUrl: (fundCode: string) =>
    utils.fetch(`${process.env.HOST}/api/mutual-fund/fund-details?fundCode=${fundCode}`),
  getSchemeChartDataUrl: (fundCode: string) => `${process.env.HOST}/api/mutual-fund/chart?fundCode=${fundCode}`,
  getBencharkSchemesUrl: (fundCode: string) => `${process.env.HOST}/api/mutual-fund/benchmark?fundCode=${fundCode}`,
  getSchemesSearchUrl: (key: string) => `${process.env.HOST}/api/mutual-fund/search?q=${key}`,
  getSchemeSubCategoriesUrl: (riskProfile: boolean) =>
    `${process.env.HOST}/api/mutual-fund/fund-sub-category-details?riskProfile=${riskProfile}`,
  getInvestmentIdeasDetails: () => `${process.env.HOST}/api/mutual-fund/investment-ideas`,
  getPlanYourGoalsSubCategories: (goal: string) =>
    `${process.env.HOST}/api/mutual-fund/plan-your-goals?goalKey=${goal}`,
  getPsmCheckDetails: (fundCode: string) => `${process.env.HOST}/api/transaction/buy/psm-check?fundCode=${fundCode}`,
  getAxisSelectDetails: (goal: string) =>`${process.env.HOST}/api/mutual-fund/axis-select-fund?category=${goal}`,
  getFundsWithModerateToHighReturns: (category: string) => `${process.env.HOST}/api/mutual-fund/risk-return-fund?category=${category}Risk`,
  logUnhandledError: (data) =>
    utils.fetch(`${process.env.HOST}/api/mutual-fund/log-error`, { data: data, method: METHODS.POST }),
});

export default schemes;
